import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'base',
            component: resolve => require(['@/components/page/common/base/Base'], resolve),
            meta: {
                title: '米阳—智慧供应链一站式解决方案服务商【官网】',
              keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+消费品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
              description: '米阳科技股份有限公司，是一家专注于为企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现商品流通全渠道的高效协同，助力商品企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的商品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。全国服务热线：0571-56865686'

            },
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: resolve => require(['@/components/page/home/Home'], resolve),
                    meta: {
                        title: '米阳—智慧供应链一站式解决方案服务商【官网】',
                        keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+消费品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
                        description: '米阳科技股份有限公司，是一家专注于为企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现商品流通全渠道的高效协同，助力商品企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的商品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'product/tms',
                    name: 'product_tms',
                    component: resolve => require(['@/components/page/product/Tms'], resolve),
                    meta: {
                        title: '米阳干线运输-米阳',
                        keywords: '米阳干线运输,干线运输,干线物流,整车物流,整车运输,物流平台,物流信息平台,物流公共平台,互联网物流,智慧物流,货运,无车承运人,无车承运,快运,货运,发货,找货,大宗商品,物流,物流信息,合作,货车,货物,货源,货车找货,货车司机',
                        description: '米阳以物流调度服务平台为中心开展运输业务。米阳自主研发的“米阳调度管理中心”通过互联网平台整合米阳资深调度服务团队和米阳诚信协作车队，实现米阳调度、公司自有调度、公司外协调度的透明协同，降低物流公司调度管理难度和管理成本，最大化使用可用资源，降低用车成本，帮助物流公司构建标准化、规范化、可扩展的调度管理服务体系、车队资源运营体系。为物流承运方提供业务标准化、管理标准化、服务标准化咨询和系统支撑，为物流承运方提供车队运营、价格体系和行情指导等资源、经验和知识积累，为物流承运方提供全程定位、保险、金融等增值服务。'
                    }
                },
                {
                    path: 'product/oms',
                    name: 'product_oms',
                    component: resolve => require(['@/components/page/product/Oms'], resolve),
                    meta: {
                        title: '执法大师-米阳',
                        keywords: '执法大师,一线执法,市场监管,市场监督,执法理念,执法主体,执法学习,执法工具,市场监管标准,市场监管经验,市场监管学习,市场监管交流,市场监管案例分享,执法问答,法律法规库',
                        description: '执法大师是米阳技术团队历时2年，完全自主研发的产品。是专为市场监管一线执法人员打造的相互交流、学习、分享的平台。几千名执法专家每日分享执法案例、执法心得、学习资源，让你轻轻松松成长为执法达人。上“执法大师”，减轻工作压力，提高执法效率。'
                    }
                },
                {
                    path: 'product/wms',
                    name: 'product_wms',
                    component: resolve => require(['@/components/page/supplychain/Chain'], resolve),
                    meta: {
                        title: '米阳智慧供应链解决方案-智慧供应链一站式解决方案-米阳',
                        keywords: '供应链,商品供应链,智慧供应链,供应链金融,供应链管理,四流合一,智慧物流,仓配一体,城市配送,仓储,运输,配送',
                        description: '米阳科技股份有限公司，是一家专注于为企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现商品流通全渠道的高效协同，助力商品企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的商品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'news/news_list',
                    name: 'news_list',
                    component: resolve => require(['@/components/page/news/NewsList'], resolve),
                    meta: {
                        title: '新闻中心-米阳',
                        keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+商品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
                        description: '米阳科技股份有限公司，是一家专注于为企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现商品流通全渠道的高效协同，助力商品企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的商品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'news/news_detail',
                    name: 'news_detail',
                    component: resolve => require(['@/components/page/news/NewsDetail'], resolve),
                    meta: {
                        // title: '新闻详情',

                    }
                },
                {
                    path: 'chain',
                    name: 'chain',
                    component: resolve => require(['@/components/page/supplychain/Chain'], resolve),
                    meta: {
                        title: '米阳智慧供应链解决方案-消费品智慧供应链一站式解决方案-米阳',
                        keywords: '供应链,消费品供应链,智慧供应链,供应链金融,供应链管理,四流合一,智慧物流,仓配一体,城市配送,仓储,运输,配送',
                        description: '米阳科技股份有限公司成立于2009年，是一家专注于为消费品商贸企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现消费品流通全渠道的高效协同，助力消费品商贸企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的消费品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。让消费品流通更高效！全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'cooperation',
                    name: 'cooperation',
                    component: resolve => require(['@/components/page/cooperation/Cooperation'], resolve),
                    meta: {
                        title: '战略合作-米阳',
                        keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+消费品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
                        description: '米阳科技股份有限公司成立于2009年，是一家专注于为消费品商贸企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现消费品流通全渠道的高效协同，助力消费品商贸企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的消费品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。让消费品流通更高效！全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'link',
                    name: 'link',
                    component: resolve => require(['@/components/page/link/Link'], resolve),
                    meta: {
                        title: '友情链接-米阳',
                        keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+商品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
                        description: '米阳科技股份有限公司成立于2009年，是一家专注于为消费品商贸企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现消费品流通全渠道的高效协同，助力消费品商贸企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的消费品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。让消费品流通更高效！全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'success',
                    name: 'success',
                    component: resolve => require(['@/components/page/success/Success'], resolve),
                    meta: {
                        title: '成功见证-米阳',
                        keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+消费品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
                        description: '米阳科技股份有限公司成立于2009年，是一家专注于为消费品商贸企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现消费品流通全渠道的高效协同，助力消费品商贸企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的消费品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。让消费品流通更高效！全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'about',
                    name: 'about',
                    component: resolve => require(['@/components/page/about/About'], resolve),
                    meta: {
                        title: '走进米阳-米阳',
                        keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+消费品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
                        description: '米阳科技股份有限公司成立于2009年，是一家专注于为消费品商贸企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现消费品流通全渠道的高效协同，助力消费品商贸企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的消费品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。让消费品流通更高效！全国服务热线：0571-56865686'
                    }
                },
                {
                    path: 'contact',
                    name: 'contact',
                    component: resolve => require(['@/components/page/contact/Contact'], resolve),
                    meta: {
                        title: '联系我们-米阳',
                        keywords: '米阳,米阳股份,米阳智链,米阳智慧供应链,供应链金融,供应链解决方案,互联网+消费品产业链,智慧物流,物流自动化,物流信息化,智能科技,物流金融,三方物流,四方物流,无车承运,物流解决方案',
                        description: '米阳科技股份有限公司成立于2009年，是一家专注于为消费品商贸企业提供智慧供应链一站式解决方案的现代科技创新型互联网+企业。提供整车、快运、城市配送、仓运配一体、供应链金融与数字化监管等多元业务，并依托领先的科技技术、智能装备实现智能自动化集成解决方案。米阳以“诚信、共享、协作、创新”的服务理念，为客户提供多元、高效的个性化定制服务，实现消费品流通全渠道的高效协同，助力消费品商贸企业良性快速发展。同时，专注于持续的技术进步和创新，致力于建立高效的消费品智慧供应链生态系统，打造国内领先的智慧供应链服务商品牌。让消费品流通更高效！全国服务热线：0571-56865686'
                    }
                }
            ]
        },
        // {
        //     path: '/map',
        //     name: 'c_map',
        //     component: resolve => require(['@/components/page/map/Map'], resolve),
        //     meta: {
        //         title: '地图'
        //     }
        // },
        {
            path: '*',
            name: 'not_found',
            component: resolve => require(['@/components/page/notfound/NotFound'], resolve),
            meta: {
                title: '找不到页面'
            }
        }
    ]
})

// 全局配置
router.beforeEach((to, from, next) => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description)
    next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js